module.exports = __webpack_public_path__ + "static/media/task-list.feb80a8f.png";